import './LoadingOverlay.scss';

import { Loader } from '@trackman/web-shared-components';
import { t } from 'utilities/TranslationUtils';

interface LoadingOverlayProps {
  isVisible: boolean;
  title?: string;
  /** When true, renders with position:absolute (parent must have position:relative).
   *  Use this to overlay a specific section without covering the full viewport. */
  contained?: boolean;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ isVisible, title, contained }) => {
  if (!isVisible) return null;
  return (
    <div className={`loading-overlay${contained ? ' loading-overlay--contained' : ''}`} data-test='loading-overlay'>
      <div className='loading-overlay-content'>
        <Loader size='large' />
        <span className='loading-overlay-text'>{title ?? t('common.loadingData')}</span>
      </div>
    </div>
  );
};

export default LoadingOverlay;
